import { render, staticRenderFns } from "./clips.vue?vue&type=template&id=153451c2&"
import script from "./clips.vue?vue&type=script&lang=js&"
export * from "./clips.vue?vue&type=script&lang=js&"
import style0 from "./clips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports